import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { fulfillmentSettingsAccessControl } from '../access-control/fulfillmentSettingsAccess.configuration'
import { fulfillmentConfigurationsPageAccessControl } from '../access-control/fulfillmentConfigurationsPageAccess.configuration'

const FulfillmentConfigurationsPage = lazy(
  () => import('../pages/FulfillmentConfigurationsPage/page')
)
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const fulfillmentSettingsRouter = (
  <DomainRoute route="fulfillment-settings" accessControl={fulfillmentSettingsAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="fulfillment-settings-fulfillment-configurations"
        component={FulfillmentConfigurationsPage}
        accessControl={fulfillmentConfigurationsPageAccessControl}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
